import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Gift, Image as ImageIcon, Loader2 } from "lucide-react";

export default function OffersView() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/offers/active").then((r) => setOffers(r.data)).catch(() => setOffers([])).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center py-24"><Loader2 className="animate-spin text-emerald-600" size={28} /></div>;

  return (
    <div className="space-y-6" data-testid="offers-view-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-heading tracking-tight flex items-center gap-2"><Gift size={24} className="text-emerald-600" /> Offers</h1>
        <p className="text-sm text-slate-500 mt-1">Latest offers from Arjun Fintech — click any card to see the full details.</p>
      </div>

      {offers.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500 text-sm" data-testid="offers-view-empty">No active offers right now. Please check back later.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {offers.map((o) => (
            <button key={o.id} data-testid={`offer-view-card-${o.id}`} onClick={() => setActive(o)} className="text-left rounded-xl border border-slate-200 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-emerald-300 transition-all flex flex-col">
              <div className="aspect-[16/9] bg-slate-100 flex items-center justify-center overflow-hidden">
                {o.image_data ? <img src={o.image_data} alt={o.title} className="w-full h-full object-cover" /> : <ImageIcon size={36} className="text-slate-300" />}
              </div>
              <div className="p-4 flex-1 flex flex-col gap-2">
                <div className="font-semibold text-slate-900">{o.title}</div>
                {o.description && <div className="text-sm text-slate-600 whitespace-pre-line line-clamp-3">{o.description}</div>}
              </div>
            </button>
          ))}
        </div>
      )}

      {active && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" onClick={() => setActive(null)} data-testid="offer-detail-overlay">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[92vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
            {active.image_data && (
              <div className="w-full aspect-[16/9] bg-slate-100 overflow-hidden flex items-center justify-center">
                <img src={active.image_data} alt={active.title} className="w-full h-full object-cover" data-testid="offer-detail-image" />
              </div>
            )}
            <div className="p-6 space-y-4 overflow-y-auto">
              <div>
                <h2 className="text-xl font-extrabold text-slate-900" data-testid="offer-detail-title">{active.title}</h2>
              </div>
              {active.description && <div className="text-sm text-slate-700 whitespace-pre-line" data-testid="offer-detail-description">{active.description}</div>}
              {active.terms_and_conditions && (
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">Terms & Conditions</div>
                  <div className="text-xs text-slate-600 whitespace-pre-line" data-testid="offer-detail-tnc">{active.terms_and_conditions}</div>
                </div>
              )}
              <div className="flex justify-end pt-2">
                <button onClick={() => setActive(null)} data-testid="offer-detail-close" className="px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold">Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
